<template>
  <div>
    <!--标题部分-->
    <public-title>
      <span>年卡介绍</span>
    </public-title>
    <div class="bg-white m-auto" style="box-sizing: border-box">
      <!--内容头部-->
      <div class="d-center-start mb-3 w-100 border-bottom pb-4">
        <div style="width: 530px;margin-left: 40px;margin-right: 100px">
          <el-carousel trigger="click" height="330px" class="mt-5">
            <el-carousel-item v-for="(item,index) in picArr" :key="index">
              <img :src="item" height="330px" @click="imgPreview (index)">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="pl-2 ml-5 text-left" style="padding-left: 100px">
          <h2 class="pt-5 font-weight-normal" style="font-size: 40px;">黄金版旅游年卡</h2>
          <p class="pt-2 mb-2">价格：
            <span class="text-danger pl-2">&yen;</span>
            <span v-if="totalNum<10000" class="text-danger" style="font-size:48px;font-weight: bold;">128</span>
            <span v-if="totalNum>=10000" class="text-danger" style="font-size:48px;font-weight: bold;">118</span>
            <span class="text-danger">元 / 张</span>
          </p>
          <p>数量：
            <i class="iconfont cursor-pointer text-blue pl-2" style="font-size: 14px;" @click="calcNum(-1)">&#xe6f2;</i>
            <input type="number" class="text-center border-bottom w-30" style="border: none" v-model="totalNum">
            <i class="iconfont cursor-pointer text-blue" style="font-size: 14px;" @click="calcNum(+1)">&#xe613;</i>
          </p>
          <el-button  class="mt-4 pl-5 pr-5 bg-danger text-white" rounded @click="isPurchase"><span class="h3">购 买</span>
          </el-button>
        </div>
      </div>
      <!--主体文字内容-->
      <div class="text-left w-100">
        <div class="d-flex mb-3 border-bottom">
          <p class="w-25 ml-5">优惠政策：</p>
          <div class="w-60 mb-3">
            <p>1.10000张以内 128元/张</p>
            <p>2.累计超出10000张 118元/张</p>
            <p>3.购买数量低于20张，邮费12元（顺丰快递）</p>
            <p>4.高于20张，顺丰包邮</p>
          </div>
        </div>
        <div class="d-flex  mb-3 border-bottom">
          <p class="w-25 ml-5">购买说明：</p>
          <div class="w-60">
            <p>可用时段：</p>
            <p class="text-muted pb-2"> 激活此卡之后一年有效期</p>
            <p>客服电话：</p>
            <p class="text-muted pb-3">0571-89986918</p>
          </div>
        </div>
        <div class="d-flex mb-3 border-bottom">
          <p class="w-25 ml-5">使用须知：</p>
          <div class="w-60 mb-3 text-muted">
            <p>1、购买此旅游年卡之后，所有产品全国顺丰配送（新疆、西藏、港澳台除外）；</p>
            <p>2、此旅游年卡需要在有效期之内激活；</p>
            <p>3、此旅游年卡一经刮开激活卡密，概不退款。</p>
            <p>4、此旅游年卡如需开票，请联系客服。</p>
            <p>5、旅游年卡（内附激活码）全国范围顺丰配送；如果急需激活码激活，请致电客服咨询。</p>
          </div>
        </div>
        <div class="d-flex mb-2">
          <p class="w-25 ml-5">产品介绍：</p>
        </div>
        <img src="/images/public/annualIntroduction.jpg" class="w-90" style="display: block;margin: auto">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CardIntroduction',
    data() {
      return {
        totalNum: 1,
        picArr: ['/images/public/annualFront.png', '/images/public/annualBack.png'],
      }
    },
    methods: {
      /*计算年卡数量*/
      calcNum(flag) {
        this.totalNum = parseInt(this.totalNum);
        this.totalNum += flag;
        if (this.totalNum < 1) this.totalNum = 1;
      },
      /*输入框检测*/
      verifyInput() {
        if (Number(this.totalNum) <= 0) return {code:false,msg:'购买年卡数量不得小于0'};
        if (Number(this.totalNum) !== Math.round(this.totalNum)) return {code:false,msg:'购买年卡数量必须为整数'};
        if (Number(this.totalNum) > 9999999) return {code:false,msg:'购买年卡数量不得大于7位数'};
        return {code:true,msg:'验证通过'};
      },
      /*提交按钮验证*/
      isPurchase() {
        let result = this.verifyInput();
        if (result.code) {
          this.$router.push({name:'OrderDetail',query:{orderType:1,num:this.totalNum}});
        } else this._alert(result.msg, null,'error');
      },
      /*图片放大*/
      imgPreview (index) {
        this._CarouselView({
          currentImg: index,
          picArray: this.picArr
        })
      },
    }
  }
</script>
